import React from 'react';
import { ProductFruits } from 'react-product-fruits';
import sha256 from 'js-sha256';
import useSubscription from '../../hooks/useSubscription';
import useUserProperties from "../../hooks/useUserProperties";

let isInitialized = false;

const ProductFruitsReporter = (() => {
  const track = (event) => {
    if (!isInitialized) {
      console.warn('Product Fruits has not been initialized for event:', event);
      return;
    }
    if (!window.productFruits?.api?.events) {
      console.warn('Product Fruits API could not be accessed for event:', event);
      return;
    }
    window.productFruits.api.events.track(event);
  };

  return { track };
})();

const getSubscriptionType = (isTrial, subscriptionPlan) => {
  if (isTrial) return 'Evaluation';
  if (subscriptionPlan === 'monthly') return 'Standard Monthly';
  if (subscriptionPlan === 'organization') return 'Organization';
  if (subscriptionPlan === 'yearly') return 'Standard Annual';
  return subscriptionPlan;
}

const ProductFruitsInit = ({ isDarkTheme, locale }) => {
  const userId = window.VSS.getWebContext()?.user?.id;
  const subscriptionQuery = useSubscription();
  
  // Only fetch user properties AFTER subscription is successfully loaded
  const userPropertiesQuery = useUserProperties({ 
    enabled: subscriptionQuery.isSuccess 
  });
  
  if (!userId) {
    console.warn('Subscription id was not found.');
    return null;
  }
  
  if (subscriptionQuery.isLoading || !subscriptionQuery.isSuccess) return null;
  if (userPropertiesQuery.isLoading || !userPropertiesQuery.isSuccess) return null;

  const storedConsent = JSON.parse(localStorage.getItem('55d-azure-user-tracking-consent'));
  const consent = storedConsent?.value?.isEnabled || false;
  const hashedUserId = sha256(userId);
  const organizationName = window.VSS.getWebContext()?.account?.name || 'Missing Organization Name';

  const {
    is_trial: isTrial,
    recurlyAccountCode,
    recurlySubscriptionId,
    recurlySubscriptionPlan,
  } = subscriptionQuery.data;

  if (!isInitialized) {
    isInitialized = true;
  }

  const { signUpAt } = userPropertiesQuery.data;

  return (
    <ProductFruits
      workspaceCode="rnRI0kbOPFDOf90i"
      language="en"
      user={{
        username: `azure-${hashedUserId}`,
        signUpAt: signUpAt,
        props: {
          Consent: consent,
          Account: recurlyAccountCode,
          Subscription: recurlySubscriptionId,
          'Subscription Type': getSubscriptionType(isTrial, recurlySubscriptionPlan),
          Theme: isDarkTheme ? 'Dark' : 'Light',
          Language: locale === 'fr-FR' ? 'French' : 'English',
          Company: organizationName,
        }
      }}
    />
  );
};

export { ProductFruitsInit, ProductFruitsReporter };
